// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__t995P","content":"Layout_content__N1pL8"};